export default __webpack_public_path__ + "static/media/icon_born.5620f458.svg";